import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { ReadExternalPrescriptionStruct } from 'src/app/shared/services/structs/orchestrator-patient/read-external-prescription.struct';
import { PresentationEnum } from '../../enum/prescription.enum';

@Component({
    selector: 'app-external-prescription-modal',
    templateUrl: './external-prescription-modal.component.html',
    styleUrls: ['./external-prescription-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternalPrescriptionModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ExternalPrescriptionModalComponent>,
    private alertService: AlertService,
    private formBuilder: FormBuilder
  ) { }

  public isLoading: boolean;
  public medicalPrescription: ReadExternalPrescriptionStruct;
  public prescriptionModel: FormGroup;
  public measurementUnitList: any[] = [];
  public presentationOthersEnum: PresentationEnum = PresentationEnum.outros;
  public idPresentation: number;

  ngOnInit(): void {
    this.medicalPrescription = this.data.prescription;
    this.isLoading = false;
    this.prescriptionModel = this.formBuilder.group({
      quantity: [{ value: '', disabled: this.data.readOnly }, Validators.required],
      description: [{ value: '', disabled: this.data.readOnly }, Validators.required],
      observation: [{ value: '', disabled: this.data.readOnly }],
      frequency: [{ value: '', disabled: this.data.readOnly }, Validators.required],
      idMeasurementUnit: [{ value: null, disabled: this.data.readOnly }],
      idPresentation: [{ value: null, disabled: this.data.readOnly }],
      presentation: [{ value: '', disabled: this.data.readOnly }],
    });
    if (this.medicalPrescription) {
      this.populateValues();
    }
    this.populateLookup();
  }

  populateLookup() {
    this.measurementUnitList = this.data.lookupMedicalCareResponse?.listMeasurementUnit;
  }

  populateValues() {
    this.prescriptionModel.get('frequency').setValue(this.medicalPrescription.frequency);
    this.prescriptionModel.get('description').setValue(this.medicalPrescription.description);
    this.prescriptionModel.get('quantity').setValue(this.medicalPrescription.quantity);
    this.prescriptionModel.get('observation').setValue(this.medicalPrescription.observation);
    this.prescriptionModel.get('idMeasurementUnit').setValue(this.medicalPrescription.idMeasurementUnit);
    this.prescriptionModel.get('idPresentation').setValue(this.medicalPrescription.idPresentation);
    this.prescriptionModel.get('presentation').setValue(this.medicalPrescription.presentation);
  }

  clickCancel() {
    this.matDialogRef.close();
  }
  close() {
    this.matDialogRef.close();
  }

  onSubmit() {
    if (this.prescriptionModel.invalid) {
      this.alertService.show('Erro', "Preencha todos os campos obrigatórios!", AlertType.error);
      return;
    }
    let newExternalPrescription: ReadExternalPrescriptionStruct = new ReadExternalPrescriptionStruct();
    newExternalPrescription.frequency = this.prescriptionModel.get('frequency').value;
    newExternalPrescription.description = this.prescriptionModel.get('description').value;
    newExternalPrescription.quantity = this.prescriptionModel.get('quantity').value ? this.prescriptionModel.get('quantity').value.toString() : null;
    newExternalPrescription.observation = this.prescriptionModel.get('observation').value;
    newExternalPrescription.idMeasurementUnit = this.prescriptionModel.get('idMeasurementUnit').value;
    newExternalPrescription.idPresentation = this.prescriptionModel.get('idPresentation').value;
    newExternalPrescription.presentation = this.prescriptionModel.get('presentation').value;
    newExternalPrescription.measurementUnitName = this.prescriptionModel.get('idMeasurementUnit').value ? this.measurementUnitList.find(x => x.idMeasurementUnit == this.prescriptionModel.get('idMeasurementUnit').value).measurementUnitName : null;
    newExternalPrescription.presentationName = this.prescriptionModel.get('idPresentation').value ? this.data.listPresentation.find(x => x.idPresentation == this.prescriptionModel.get('idPresentation').value).presentationName : null;
    this.matDialogRef.close({ newExternalPrescription: newExternalPrescription });
  }

  onChangePresentation(event: number) {
    this.idPresentation = event;
    if (this.idPresentation == this.presentationOthersEnum.valueOf()) {
      this.prescriptionModel.get('presentation').setValidators(Validators.required);
    }
    else {
      this.prescriptionModel.get('presentation').setValue(null);
      this.prescriptionModel.get('presentation').setValidators(Validators.nullValidator);
    }

    this.prescriptionModel.get('presentation').updateValueAndValidity();
  }
}